/**
 * =========================================================================================
 * Component - UPagination
 * =========================================================================================
 **/

import React, { useMemo } from 'react';
import { COLOR, PAGINATION } from "../constant";
import ReactPaginate from 'react-paginate';
import Select from 'react-select';
import * as Icon from 'ubs-icons';
import { getKeyName } from '../function';

const LIMIT_OPTIONS = [
    { label: '20', value: 20 },
    { label: '40', value: 40 },
    { label: '60', value: 60 },
    { label: '80', value: 80 },
    { label: '100', value: 100 }
];

const UPagination = React.memo((props) => {
    const totalRecords = props.totalRecords ?? props.pageCount ?? 0;
    const currentPage = props.currentPage || (typeof props.page === 'object' ? props.page?.currentPage : props.page);
    const limit = props.limit || (typeof props.page === 'object' ? props.page?.limit : null) || PAGINATION.LIMIT;
    const options = props.options || LIMIT_OPTIONS;

    const recordsPerPage = useMemo(() => {
        const found = getKeyName(options, limit);
        return found || options[0];
    }, [options, limit]);

    const pageCount = useMemo(() => {
        const count = Math.ceil(totalRecords / limit);
        return !isNaN(count) && count > 0 ? count : 0;
    }, [totalRecords, limit]);

    const paginationClick = (data) => {
        props.onChange(data);
    };

    const handlePageClick = ({ selected: selectedPage }) => {
        paginationClick({ limit, currentPage: selectedPage + 1 });
        if (props?.onPageChange) props?.onPageChange();
        const dom = document.querySelector(props.scrollSelectorClassName || '.u_table-resource');
        dom?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    };

    const handleLimit = (data) => {
        paginationClick({ limit: data.value, currentPage: PAGINATION.CURRENT_PAGE });
    };

    return (
        <React.Fragment>
            <div className={`u_pagination ${pageCount === 0 ? 'u_pagination-hidden' : ''}`} id="u_pagination">
                <div className="u_pagination-record u_flex u_align-center">
                    <span className="u_pagination-entries u_mr-10">Entries</span>
                    <div className="u_pagination-record-wpr">
                        <Select
                            classNamePrefix="u_record"
                            options={options}
                            menuPlacement="top"
                            isSearchable={false}
                            isClearable={false}
                            isMulti={false}
                            value={recordsPerPage}
                            defaultValue={recordsPerPage}
                            onChange={handleLimit}
                            placeholder=""
                            data-testid="fw.upagination.input.1.select"
                            inputId="hrms.common.upagination"
                            instanceId="hrms.common.upagination.options"
                        />
                    </div>
                </div>
                <div>
                    <ReactPaginate
                        previousLabel={<Icon.LeftArrow size={15} fill={COLOR.u_icon_bg} />}
                        nextLabel={<Icon.RightArrow size={15} fill={COLOR.u_icon_bg} />}
                        pageCount={pageCount}
                        onPageChange={handlePageClick}
                        containerClassName="u_flex"
                        pageLinkClassName="u_pagination-link"
                        previousLinkClassName="u_pagination-link u_pagination-link-previous"
                        breakLinkClassName="u_pagination-link u_pagination-link-break"
                        nextLinkClassName="u_pagination-link u_pagination-link-next"
                        disabledLinkClassName="u_pagination-link-disabled"
                        activeLinkClassName="u_pagination-link-active"
                        forcePage={currentPage ? currentPage - 1 : 0}
                    />
                </div>

            </div>
        </React.Fragment>
    );
});

export default UPagination;
